import { checkImportEnvironment } from './import-check';
import {
  isRegulatedMarket,
  attachGdprActiveField,
  NON_REGULATED_MARKET_DEFAULTS,
  REGULATED_MARKET_DEFAULTS,
  type TrackingPreferences,
} from './isomorphic';

// Ignore all set operations
// eslint-disable-next-line @typescript-eslint/no-empty-function
const setPreferences = (_prefs?: unknown): void => {};

// No initialisation needed
const isGdprInitialised = (): boolean => true;

// Initial session is completed
const isGdprInitSessionActive = (): boolean => false;

// Ignore all set operations
// eslint-disable-next-line @typescript-eslint/no-empty-function
const setInitialPreferences = (_market: string): void => {};

// Return market's default if market is given, otherwise throw
const getPreferences = (market: string): TrackingPreferences => {
  checkImportEnvironment();
  if (!market)
    throw new Error('Market should be provided to get tracking preferences');
  const marketDefaults = isRegulatedMarket(market)
    ? REGULATED_MARKET_DEFAULTS
    : NON_REGULATED_MARKET_DEFAULTS;
  return attachGdprActiveField(market, marketDefaults);
};

// Never show cookie banner
const showCookieBanner = (market: string): boolean => {
  if (!market)
    throw new Error(
      'Market should be provided to determine if cookie-banner is required to be shown',
    );
  return false;
};

// Ignore all set operations
// eslint-disable-next-line @typescript-eslint/no-empty-function
const acknowledgeTrackingSettings = (): void => {};

export {
  getPreferences,
  setPreferences,
  setInitialPreferences,
  acknowledgeTrackingSettings,
  showCookieBanner,
  isGdprInitialised,
  isGdprInitSessionActive,
};
